import { DocumentFilterPicker } from '@/components/search/DocumentFilterPicker'
import { useDocumentFilter } from './hooks/use-document-filter'
import { useDocumentSearch } from './hooks/use-document-search'

interface DocumentFilterProps {
  caseId: string
  /** Runs after the choice changed; the page reads the choice itself from `useDocumentFilter`. */
  onChange?: () => void
  className?: string
}

/**
 * The document filter of the Research pages. Holding the search down here keeps its keystrokes
 * from re-rendering the page's results.
 */
export function DocumentFilter({ caseId, onChange, className }: DocumentFilterProps) {
  const [document, setDocument] = useDocumentFilter(caseId)
  const search = useDocumentSearch(caseId)
  return (
    <DocumentFilterPicker
      value={document}
      onChange={next => {
        setDocument(next)
        onChange?.()
      }}
      search={search}
      className={className}
    />
  )
}
